import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { Conexion } from "../objetos/conexion";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { SimpleResponse } from "../objetos/simple-response";

  @Injectable({
    providedIn: 'root'
  })

  export class ConexionesService {
    private baseUrl = environment.conexiones_url;

    private _conexiones = new BehaviorSubject<Conexion[]>([]);
    public readonly conexionesRO: Observable<Conexion[]> = this._conexiones.asObservable();


    constructor(private http: HttpClient) {

      //Sin esto no persiste el subject al actualizar la pagina
      if (localStorage.getItem("conexiones")) {
        this._conexiones.next( JSON.parse(localStorage.getItem("conexiones") || '') );
      }

    }


    public asignarConexionesLogin = (): void  => {
      this._consultarConexionLogin().subscribe({
        next: (res: SimpleResponse) => {
          this._conexiones.next([res.payload]);
        },
        // El `LogoutInterceptor` ya se encarga de la alerta/logout de cara al
        // usuario ante un 401 — sin este `error`, un fallo aquí (ej. durante
        // la migración del API de autenticación) se convierte en una
        // excepción no controlada en vez de solo no actualizar el subject.
        error: () => {},
      });
    }

    /** A diferencia de `asignarConexionesLogin`, esta sí le devuelve el
     * resultado a quien la llama — justo después del login es la primera
     * consulta autenticada, y su fallo (ej. 401 durante la migración del API
     * de autenticación) es una señal de que la sesión recién creada no sirve;
     * el llamador (login.component) decide qué hacer (navegar al menú o
     * forzar un redirect a /auth/login) en vez de que quede como
     * fire-and-forget compitiendo con esa navegación. */
    public asignarConexionesAll = (): Observable<SimpleResponse>  => {
      return this._consultarTodasConexiones().pipe(
        tap((res: SimpleResponse) => {
          this._conexiones.next(res.payload);
          //Sin esto no persiste el subject al actualizar la pagina
          localStorage.setItem("conexiones",JSON.stringify(res.payload))
        }),
      );
    }

    public buscarConexion = (api: string) =>  {
      const conexion = this._conexiones.getValue().find( conexion => conexion.API?.toUpperCase() == api?.toUpperCase());
      
      return conexion;
    }

    private _consultarTodasConexiones = () => {
      const entorno = environment.conexiones_entorno;
      const url = `${this.baseUrl}/servicios/APIS/${entorno}`;
        return this.http.get(url,{
          headers:{
            'x-auth': localStorage.getItem('token') || ''
          }
        }).pipe(
          tap( (resp:any) => resp)
        )
  }

    private _consultarConexionLogin = () => {
        const entorno = environment.conexiones_entorno;
        const url = `${this.baseUrl}/servicios/login/${entorno}`;
        return this.http.get(url).pipe(
            tap( (resp:any) => resp)
          )
    }


  }
